"use client";

import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import Link from "next/link";
import { X } from "lucide-react";

export function NotificationBanner() {
  const [activeUsers, setActiveUsers] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Fetch active users count after mount to avoid hydration mismatch
    // In production, this would be a real API call to your analytics
    const fetchUsers = async () => {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 100));
      setActiveUsers(Math.floor(Math.random() * 50) + 150); // 150-200 users
    };
    fetchUsers();
  }, []);

  if (!isVisible) return null;

  return (
    <div className="bg-stone-800 text-white py-2 px-4 relative">
      <div className="container mx-auto flex items-center justify-between gap-4">
        {/* Left: Active users */}
        <div className="flex items-center gap-2 text-sm">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span className="text-stone-200">
            {activeUsers !== null ? (
              <>
                <strong className="font-semibold">{activeUsers}</strong> people
                browsing now
              </>
            ) : (
              "Loading..."
            )}
          </span>
        </div>

        {/* Right: Marketing text + CTA */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-stone-200 hidden sm:inline">
            Own a plaster contractor business?{" "}
            <Link href="/advertise" className="hover:underline">
              <strong className="font-semibold text-white cursor-pointer">
                Get Premium visibility.
              </strong>
            </Link>
          </span>
          <Button
            asChild
            size="sm"
            variant="secondary"
            className="text-xs h-7 px-3"
          >
            <Link href="/advertise">Learn More</Link>
          </Button>
        </div>

        {/* Close button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-stone-400 hover:text-white transition-colors p-1"
          aria-label="Close banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
